import axiosInstance from '@client/utils/axios.util';
import { logger } from '@client/utils/logger.util';

import type {
  IFeatureMarketplaceListItem,
  IMarketplaceListItem,
} from '@common/types';

export interface IMarketplaceListParams {
  featured?: boolean;
  q?: string;
  cursor?: string;
  limit?: number;
}

export interface IMarketplaceListResponse {
  items: IMarketplaceListItem[];
  nextCursor: string | null;
}

export const listMarketplace = async (
  params: IMarketplaceListParams = {},
): Promise<IMarketplaceListResponse> => {
  try {
    const query: Record<string, string> = {};
    if (params.featured === true) query.featured = 'true';
    if (params.q) query.q = params.q;
    if (params.cursor) query.cursor = params.cursor;
    if (params.limit) query.limit = String(params.limit);

    const { data } = await axiosInstance.get<IMarketplaceListResponse>(
      '/marketplace',
      { params: query },
    );
    return data;
  } catch (error) {
    logger.error('listMarketplace', error);
    throw error;
  }
};

export const setMarketplaceFeatured = async (
  id: string,
  featured: boolean,
): Promise<{ id: string; featured: boolean }> => {
  try {
    const { data } = await axiosInstance.patch<{
      id: string;
      featured: boolean;
    }>(`/admin/marketplace/${id}/feature`, { featured });
    return data;
  } catch (error) {
    logger.error('setMarketplaceFeatured', error);
    throw error;
  }
};

export interface IMarketplaceFeaturesListResponse {
  items: IFeatureMarketplaceListItem[];
  nextCursor: string | null;
}

export const listMarketplaceFeatures = async (
  params: IMarketplaceListParams = {},
): Promise<IMarketplaceFeaturesListResponse> => {
  try {
    const query: Record<string, string> = {};
    if (params.featured === true) query.featured = 'true';
    if (params.q) query.q = params.q;
    if (params.cursor) query.cursor = params.cursor;
    if (params.limit) query.limit = String(params.limit);

    const { data } = await axiosInstance.get<IMarketplaceFeaturesListResponse>(
      '/marketplace/features',
      { params: query },
    );
    return data;
  } catch (error) {
    logger.error('listMarketplaceFeatures', error);
    throw error;
  }
};

export const setMarketplaceFeatureFeatured = async (
  id: string,
  featured: boolean,
): Promise<{ id: string; featured: boolean }> => {
  try {
    const { data } = await axiosInstance.patch<{
      id: string;
      featured: boolean;
    }>(`/admin/marketplace/features/${id}/feature`, { featured });
    return data;
  } catch (error) {
    logger.error('setMarketplaceFeatureFeatured', error);
    throw error;
  }
};
